import { Reveal } from "@/components/Reveal";
import { ScrambleText } from "@/components/ScrambleText";

const ENVS = [
  { label: "ENTERPRISE", texture: "texture-enterprise", img: "/device.webp", imgClass: "bottom-0 right-6 h-2/3", spec: "Reference housing" },
  { label: "DEFENSE", texture: "texture-defense", img: "/device_defense.webp", imgClass: "bottom-0 right-6 h-2/3", spec: "Ruggedized housing" },
  { label: "FIELD", texture: "texture-field", img: "/device_gold.png", imgClass: "bottom-0 right-8 h-3/5", spec: "Sealed-cover housing" },
  { label: "HOME", texture: "texture-home", img: "/device_ring.png", imgClass: "bottom-0 right-4 h-[52%] -rotate-6", spec: "Glass-face housing" },
];

export default function Protects() {
  const jumpToVariant = (i) => {
    window.dispatchEvent(new CustomEvent("vg:select-device", { detail: i }));
    if (window.__lenis) window.__lenis.scrollTo(0);
    else window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <section id="protects" data-testid="protects-section" className="px-6 py-28 sm:px-10 lg:px-20 lg:py-36">
      <div className="mx-auto max-w-7xl">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.35em] text-[#C4A24C]"><ScrambleText text="04 / Who It Protects" /></p>
        </Reveal>
        <div className="mt-12 grid gap-6 sm:grid-cols-2">
          {ENVS.map((env, i) => (
            <Reveal key={env.label} delay={i * 0.1} className="h-full">
              <div
                data-testid={`env-card-${env.label.toLowerCase()}`}
                onClick={() => jumpToVariant(i)}
                role="button"
                aria-label={`View the ${env.label.toLowerCase()} device`}
                className={`group relative aspect-[16/10] cursor-pointer overflow-hidden border border-white/5 transition-colors duration-500 hover:border-[#C4A24C] ${env.texture}`}
              >
                <span className="absolute left-6 top-6 font-serif text-sm tracking-[0.35em] text-[#C4A24C]">
                  {env.label}
                </span>
                <span
                  data-testid={`env-spec-${env.label.toLowerCase()}`}
                  className="absolute left-6 top-12 text-[10px] uppercase tracking-[0.25em] text-[#6B7280]"
                >
                  {env.spec}
                </span>
                <img
                  src={env.img}
                  alt=""
                  aria-hidden="true"
                  className={`absolute w-auto opacity-90 transition-transform duration-500 ease-out group-hover:-translate-y-1.5 ${env.imgClass}`}
                  draggable="false"
                />
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
